import { render, staticRenderFns } from "./carrierModal.vue?vue&type=template&id=47a31591&scoped=true"
import script from "./carrierModal.vue?vue&type=script&lang=js"
export * from "./carrierModal.vue?vue&type=script&lang=js"
import style0 from "./carrierModal.vue?vue&type=style&index=0&id=47a31591&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a31591",
  null
  
)

export default component.exports